import { useFeatureFlag, useFeatureFlagsReady } from '../../contexts/featureFlagContext';
/**
 * Growth redesign, registries (REG-08). Full-page registry records (contact,
 * company, labor category, vehicle, gov org) and the unified review queue.
 * Off = today's drawers; every record URL redirects to the drawer.
 */ export const REGISTRIES_RECORDS_FLAG = 'registries_records_v1';
/** People movement page (org chart over time, movement between organizations). */ export const PEOPLE_MOVEMENT_FLAG = 'people_movement_v1';
/**
 * True only once flags are loaded and the records flag is on. A missing or
 * not-yet-loaded flag reads as off, so the list never flashes the new UI.
 */ export function useRegistryRecordsEnabled() {
    const ready = useFeatureFlagsReady();
    const on = useFeatureFlag(REGISTRIES_RECORDS_FLAG);
    return ready && on === true;
}
